/*
  Copy this file to assets/category-groups-grid.js in a Shopify theme.
  It powers the horizontal navigation for the Category groups grid section.
*/

(() => {
  const SECTION_SELECTOR = '.shopify-section--mc-category-groups-grid';
  const SLIDER_SELECTOR = '[data-mc-category-slider]';
  const VIEWPORT_SELECTOR = '[data-mc-category-slider-viewport]';
  const PREV_SELECTOR = '[data-mc-category-slider-prev]';
  const NEXT_SELECTOR = '[data-mc-category-slider-next]';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getStep(viewport) {
    const firstCard = viewport.querySelector('.mc-category-groups__card-wrap');
    if (!firstCard) return Math.max(220, Math.round(viewport.clientWidth * 0.8));

    const cardRect = firstCard.getBoundingClientRect();
    const styles = window.getComputedStyle(viewport);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

    return cardRect.width + gap;
  }

  function initSlider(slider) {
    const viewport = slider.querySelector(VIEWPORT_SELECTOR);
    const prevButton = slider.querySelector(PREV_SELECTOR);
    const nextButton = slider.querySelector(NEXT_SELECTOR);

    if (!viewport || !prevButton || !nextButton) return;

    if (slider.dataset.mcCategorySliderInitialized === 'true') {
      return;
    }

    slider.dataset.mcCategorySliderInitialized = 'true';
    let canLoop = false;
    let isAnimating = false;

    const updateLayoutMode = () => {
      const cards = viewport.querySelector('.mc-category-groups__grid');
      const hasEnoughItems = Boolean(cards && cards.children.length > 1);

      // Medir siempre en modo carrusel: en modo fit el flex comprime y oculta el overflow real.
      slider.classList.add('mc-category-groups__slider--carousel');
      slider.classList.remove('mc-category-groups__slider--fit');

      const hasOverflow = viewport.scrollWidth - viewport.clientWidth > 1;
      const useCarousel = hasOverflow;

      slider.classList.toggle('mc-category-groups__slider--carousel', useCarousel);
      slider.classList.toggle('mc-category-groups__slider--fit', !useCarousel);

      if (!useCarousel) {
        viewport.scrollLeft = 0;
      }

      canLoop = hasEnoughItems && useCarousel;

      prevButton.hidden = !canLoop;
      nextButton.hidden = !canLoop;
      prevButton.disabled = !canLoop;
      nextButton.disabled = !canLoop;
      prevButton.setAttribute('aria-disabled', String(!canLoop));
      nextButton.setAttribute('aria-disabled', String(!canLoop));
    };

    const onPrev = () => {
      if (!canLoop) return;
      if (isAnimating) return;

      const cards = viewport.querySelector('.mc-category-groups__grid');
      if (!cards || cards.children.length <= 1) return;

      const step = getStep(viewport);
      const lastCard = cards.lastElementChild;
      if (!lastCard) return;

      isAnimating = true;

      cards.prepend(lastCard);
      viewport.scrollLeft += step;

      requestAnimationFrame(() => {
        viewport.scrollBy({
          left: -step,
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
        });

        window.setTimeout(() => {
          isAnimating = false;
        }, prefersReducedMotion.matches ? 0 : 360);
      });
    };

    const onNext = () => {
      if (!canLoop) return;
      if (isAnimating) return;

      const cards = viewport.querySelector('.mc-category-groups__grid');
      if (!cards || cards.children.length <= 1) return;

      const step = getStep(viewport);
      const firstCard = cards.firstElementChild;
      if (!firstCard) return;

      isAnimating = true;

      viewport.scrollBy({
        left: step,
        behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
      });

      window.setTimeout(() => {
        cards.append(firstCard);
        viewport.scrollLeft -= step;
        isAnimating = false;
      }, prefersReducedMotion.matches ? 0 : 360);
    };

    prevButton.addEventListener('click', onPrev);
    nextButton.addEventListener('click', onNext);
    window.addEventListener('resize', updateLayoutMode, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(() => updateLayoutMode());
      resizeObserver.observe(viewport);

      const cards = viewport.querySelector('.mc-category-groups__grid');
      if (cards) {
        resizeObserver.observe(cards);
      }
    }

    if (viewport.querySelector('.mc-category-groups__card-image')) {
      viewport.querySelectorAll('.mc-category-groups__card-image').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', updateLayoutMode, { once: true });
      });
    }

    updateLayoutMode();
  }

  function initWithin(root = document) {
    root.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', () => initWithin(document));
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.matches && event.target.matches(SECTION_SELECTOR)) {
      initWithin(event.target);
      return;
    }

    if (event.target) {
      initWithin(event.target);
    }
  });
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target && event.target.matches && event.target.matches(SECTION_SELECTOR)) {
      initWithin(event.target);
    }
  });

  initWithin(document);
})();
